<div class="card card-redlaboral m-4">
    <div class="card-body">
        <!-- Encabezado -->
        <div class="row">
            <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                <h4 class="mt-0 mb-0 text-primary">
                    <i class="fa-solid fa-users"></i>
                    Usuarios
                </h4>
            </div>
            <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-end">
                <button type="button" class="btn btn-success" (click)="openAddUserModal()">
                    <i class="fa-solid fa-plus"></i>
                    Nuevo usuario
                </button>
            </div>
        </div>

        <!-- Filtros básicos -->
        <div class="row mt-3">
            <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div class="form-group mb-3">
                    <label>Buscar usuario</label>
                    <div>
                        <input type="text" class="form-control" [(ngModel)]="filter.filterValue" placeholder="Nombre, correo o usuario" />
                    </div>
                </div>
            </div>
            <div class="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div class="mt-button">
                    <button type="button" class="btn btn-primary" (click)="onSearch()">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        Buscar
                    </button>
                    <a href="javascript:void(0);" class="text-decoration-none mx-1" (click)="showFilter()">
                        <i class="fa-solid fa-filter"></i>
                        Más filtros
                    </a>
                </div>
            </div>
        </div>

        <!-- Filtros avanzados -->
        @if (showFilters) {
            <div class="card mb-2">
                <div class="card-body">
                    <div class="row">
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label>Filtrar por</label>
                                <div>
                                    <select class="form-control" [(ngModel)]="filter.filterKey">
                                        <option value="">Seleccione un filtro</option>
                                        <option value="userName">Nombre de usuario</option>
                                        <option value="email">Correo electrónico</option>
                                        <option value="fullName">Nombre completo</option>
                                        <option value="province">Provincia</option>
                                        <option value="municipality">Municipio</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="mt-button">
                                <button type="button" class="btn btn-primary" (click)="onSearch()">
                                    <i class="fa-solid fa-magnifying-glass"></i>
                                    Aplicar filtros
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

        <!-- Indicador de carga -->
        @if (isLoading) {
            <div class="d-flex justify-content-center my-4">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                </div>
            </div>
        }

        <!-- Tabla de usuarios -->
        @if (!isLoading) {
            <hr class="mt-3 mb-3" />
            <div class="table-responsive">
                <table class="table table-theme">
                    <thead>
                        <tr>
                            <th class="text-start" width="60px"></th>
                            <th class="text-start">Usuario</th>
                            <th class="text-start">Nombre</th>
                            <th class="text-start">Correo</th>
                            <th class="text-start">Provincia</th>
                            <th class="text-center">Estado</th>
                            <th class="text-center" width="230px">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        @if (users.length === 0) {
                            <tr>
                                <td colspan="7" class="text-center py-4">
                                    <i class="fa-solid fa-info-circle me-2"></i>
                                    No se encontraron usuarios con los criterios de búsqueda.
                                </td>
                            </tr>
                        }
                        @for (user of users; track user.userId) {
                            <tr>
                                <td class="text-start p-0">
                                    <img src="assets/Images/profile.jpg" alt="foto" class="img-fluid rounded" style="max-width: 50px;" />
                                </td>
                                <td class="text-start">
                                    <span class="badge rounded-pill text-bg-primary">{{ user.userName }}</span>
                                </td>
                                <td class="text-start">{{ user.fullName }}</td>
                                <td class="text-start">{{ user.email }}</td>
                                <td class="text-start">{{ user.province || 'No especificada' }}</td>
                                <td class="text-center">
                                    <span class="badge rounded-pill" [ngClass]="user.isLocked ? 'text-bg-danger' : 'text-bg-success'">
                                        {{ user.isLocked ? 'Bloqueado' : 'Activo' }}
                                    </span>
                                </td>
                                <td class="text-center">
                                    <!-- <button type="button" class="btn btn-sm btn-primary me-1" title="Ver detalles" (click)="openViewUserModal(user)">
                                        <i class="fa-solid fa-eye"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-info me-1" title="Editar usuario" (click)="openEditUserModal(user)">
                                        <i class="fa-solid fa-edit"></i>
                                    </button> -->
                                    <!-- <button type="button" class="btn btn-sm btn-warning me-1" title="Resetear contraseña" (click)="resetPassword(user.userId)">
                                        <i class="fa-solid fa-key"></i>
                                    </button> -->
                                    @if (!user.isLocked) {
                                        <button type="button" class="btn btn-sm btn-danger" title="Bloquear usuario" (click)="blockUser(user.userId)">
                                            <i class="fa-solid fa-lock"></i>
                                        </button>
                                    } @else {
                                        <button type="button" class="btn btn-sm btn-success" title="Desbloquear usuario" (click)="unblockUser(user.userId)">
                                            <i class="fa-solid fa-lock-open"></i>
                                        </button>
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>

            <!-- Componente de paginación -->
            @if (users.length > 0) {
                <app-pagination 
                    [page]="filter.page" 
                    [pageSize]="filter.pageSize" 
                    [totalItems]="totalItems"
                    (pageChange)="onPageChange($event)"
                    (pageSizeChange)="onPageSizeChange($event)">
                </app-pagination>
            }
        }
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modalBloquearUser" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="modalBloquearUserLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalBloquearUserLabel">Bloquear usuario</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="form-group mb-3">
                    <label>Razón del bloqueo</label>
                    <div>
                        <select class="form-control">
                            <option value=""></option>
                            <option value="1">Razón de bloqueo A</option>
                            <option value="2">Razón de bloqueo A</option>
                            <option value="3">Razón de bloqueo A</option>
                        </select>
                    </div>
                </div>
                <div class="form-group mb-3">
                    <label>Comentario</label>
                    <div>
                        <textarea class="form-control" rows="5"></textarea>
                    </div>
                </div>
                <hr class="mt-3 mb-3" />
                <div class="mt-2 mb-2 text-end">
                    <button type="button" class="btn btn-danger">
                        Bloquear usuario
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>